import { gql } from "@apollo/client";

export const SystemFilesTotal = gql`
    query SystemFilesTotal($id: ID!) {
        system(id: $id) {
            id
            installedBaseNode {
                fileList {
                    total
                }
            }
        }
    }
`;
